module.exports = __webpack_public_path__ + "media/images/background_graphics/publication_graphic_mobile_b-134d3bf1ad39bfcb60f02bc22090f266.svg";